import ScrollReveal from '@/components/ui/ScrollReveal'
import { clients } from '@/data/projects'

export default function ClientLogos() {
  return (
    <ScrollReveal>
      <div className="flex flex-col gap-6">
        <h3 className="text-label uppercase tracking-widest text-text-muted">Trusted By</h3>
        <div className="flex flex-wrap items-center gap-6 md:gap-10">
          {clients.map((client) => (
            <img
              key={client.name}
              src={client.src}
              alt={`${client.name} logo`}
              loading="lazy"
              decoding="async"
              className="h-6 md:h-8 w-auto opacity-60 hover:opacity-100 transition-opacity"
            />
          ))}
        </div>
      </div>
    </ScrollReveal>
  )
}
